import React, { useEffect, useState } from 'react';
import { useKmap } from '../../hooks/useKmap';
import {
    escapeInvalidBrackets,
    getHash,
    getRelatedProps,
    getUniqueKeys,
    markTibetan,
    queryID,
    UnicodeDisplay,
} from '../common/utils';
import MandalaSkeleton from '../common/MandalaSkeleton';
import ReactHtmlParser from 'react-html-parser';
import Collapse from 'react-bootstrap/Collapse';
import { Link } from 'react-router-dom';
import { HtmlCustom } from '../common/MandalaMarkup';
import { useDictionaryStore } from '../../hooks/useDictionaryStore';
import { useView } from '../../hooks/useView';

export default function TranslationEquivalent({ lookup, dictmeta = null }) {
    const { dictionaries } = useDictionaryStore();
    const [isOpen, setOpen] = useState(true);
    const [hidden, setHidden] = useState(false);
    const [selDef, setSelDef] = useState(''); // Defintion selected by user
    const termView = useView((state) => state['terms']).split('|')[1];
    const setSelectedDef = (val) => {
        let newval = val;
        if (val === selDef) {
            newval = '';
            setOpen(true);
        }
        setSelDef(newval);
    };
    let [wd, id] = lookup?.split(':');
    // console.log('id split', wd, id);
    if (id.includes('.')) {
        id = id.split('.')[0];
    }
    const term_id = queryID('terms', id);
    //console.log('termid', term_id, lookup);
    const {
        isLoading: isTermLoading,
        data: termdata,
        isError: isTermError,
        error: termError,
    } = useKmap(term_id, 'info', false, false);

    useEffect(() => {
        if (selDef?.length > 0) {
            setOpen(false);
        }
    }, [selDef]);

    if (isTermLoading) {
        return <MandalaSkeleton />;
    }

    // console.log(wd, termdata);

    const transeq = getRelatedProps(termdata, 'translation_equivalent_');
    //console.log('transeq', transeq);

    const defchild = termdata?._childDocuments_?.filter((cd, i) => {
        return cd.block_child_type === 'related_definitions';
    });

    const donesrcs = {};
    Object.keys(transeq).forEach((key, n) => {
        const tscont = termdata[`translation_equivalent_${key}_content_s`];
        const tslang = termdata[`translation_equivalent_${key}_language_s`];
        const tssrc = termdata[`translation_equivalent_${key}_source_code_ss`];
        const srccodes = Array.isArray(tssrc) ? tssrc : [tssrc];
        srccodes.forEach((srccode) => {
            const defind = defchild.findIndex(
                (def) => def.related_definitions_source_code_s === srccode
            );
            if (defind > -1) {
                defchild[defind]['related_definitions_content_latinu'] +=
                    ', ' + tscont;
            } /*else if (srccode in donesrcs) {
                const index = donesrcs[srccode];
                defchild[index].related_definitions_content_latinu += tscont;
            }*/ else {
                const newdef = {
                    related_definitions_source_code_s: srccode,
                    related_definitions_content_latinu: tslang + ': ' + tscont,
                };
                //console.log("pushing", newdef);
                defchild.push(newdef);
            }
            donesrcs[srccode] = n;
        });
    });

    const deflist = {};
    const dictlist = {};
    if (Array.isArray(defchild)) {
        defchild.forEach((c, n) => {
            if (c?.related_definitions_source_code_s) {
                const srccode = c?.related_definitions_source_code_s;
                if (srccode in deflist) {
                    const defcontent = c.related_definitions_content_latinu;
                    //console.log("defcontent", defcontent);
                    if (
                        typeof deflist[srccode]
                            ?.related_definitions_content_latinu === 'string' &&
                        !deflist[
                            srccode
                        ]?.related_definitions_content_latinu.includes(
                            defcontent
                        )
                    ) {
                        deflist[srccode].related_definitions_content_latinu +=
                            c.related_definitions_content_latinu;
                    }
                } else {
                    deflist[srccode] = c;
                }
                dictlist[srccode] = dictmeta[srccode];
            } /*else {
                let did = c?.id;
                if (did.includes('definitions')) {
                    const dpts = did.split('definitions');
                    did = 'mandala' + dpts[1];
                }
                deflist[did] = c;
                dictlist[did] = { code: did };
            }*/
        });
    }
    /*
    console.log('dictmeta', dictmeta);
    console.log('dictlist', dictlist);
    console.log('deflist', deflist);
*/

    if (Array.isArray(dictmeta)) {
        dictmeta.forEach((dm, dmi) => {
            dictlist[dm.code] = dm;
        });
    }

    const icon = isOpen ? (
        <span className="icon shanticon-minus"></span>
    ) : (
        <span className="icon shanticon-plus"></span>
    );

    let mainclass = isOpen ? 'open' : 'closed';
    if (hidden) {
        mainclass += ' hidden';
    }
    const existing_keys = Object.keys(dictlist).filter((ky, kyi) => {
        return Object.keys(deflist).includes(ky);
    });
    let mainkey = selDef?.length > 0 ? selDef : existing_keys[0];

    const hideMe = () => {
        setHidden(true);
    };

    let has_higgins = false;
    // console.log('termView', termView, termdata);
    const termhead =
        id === 'nf' ? (
            wd
        ) : termView === 'roman.scholar' ? (
            termdata['name_' + termView][0]
        ) : (
            <UnicodeDisplay w={!wd.endsWith('&#3851;') ? wd + '&#3851;' : wd} />
        );
    const aclass = termView === 'roman.scholar' ? '' : 'tib';

    const hash = getHash(wd);
    return (
        <div className={`tt-equiv ${mainclass}`}>
            <h3 className="entry-head" id={hash}>
                <a className="entry-toggle" onClick={() => setOpen(!isOpen)}>
                    {icon}
                </a>
                <Link
                    className={aclass}
                    to={`/terms/${id}`}
                    target="_blank"
                    title="View term’s full entry"
                >
                    {termhead}
                </Link>{' '}
                <span className="term-id">(terms-{id})</span>
                <a
                    onClick={() => {
                        window.scrollTo(0, 0);
                    }}
                    title="Back to Top"
                >
                    <span className="icon shanticon-angle-up"></span>
                </a>{' '}
            </h3>
            {termdata?.response?.numFound === 0 && (
                <div className={`not-found`}>Not Found</div>
            )}
            <div className={`main-def`}>
                <Translation
                    key={['translation', 'main']}
                    dict={dictlist[mainkey]}
                    data={deflist[mainkey]}
                    setSelect={setSelectedDef}
                    selected={true}
                    style="main"
                />
            </div>
            <div className="hide-link">
                <span> </span>
                <a onClick={hideMe} title="Remove this word from result list">
                    <span className="icon shanticon-cancel-circle"></span>
                </a>
            </div>
            <Collapse in={isOpen}>
                <table>
                    <tbody>
                        {Object.keys(dictlist)?.map((did, di) => {
                            if (deflist[did] && dictionaries[did].selected) {
                                if (
                                    deflist[did]
                                        .related_definitions_in_house_source_code_s ===
                                    'higgins'
                                ) {
                                    has_higgins = true;
                                }
                                const tn = has_higgins ? di : di + 1;
                                return (
                                    <Translation
                                        key={['transaltion', di]}
                                        n={tn}
                                        dict={dictlist[did]}
                                        data={deflist[did]}
                                        setSelect={setSelectedDef}
                                        selected={did === selDef}
                                        termView={termView}
                                    />
                                );
                            }
                        })}
                    </tbody>
                </table>
            </Collapse>
        </div>
    );
}

function Translation({
    n,
    dict,
    data,
    setSelect,
    selected,
    termView,
    style = 'normal',
}) {
    // console.log("In translation", n, dict, data);
    const [content, setContent] = useState('');
    const [tibclass, setTibClass] = useState('');

    useEffect(() => {
        let newcontent = data?.related_definitions_content_tibtu;
        if (!newcontent) {
            newcontent = data?.related_definitions_content_latinu;
        }
        if (newcontent) {
            let showme = false;
            /*
            if (data?.id === "terms-220724_definitions-668284") {
                console.log("content for " + data?.id, newcontent);
                console.log("View", termView);
                showme = true;
            }*/
            newcontent = escapeInvalidBrackets(newcontent);
            newcontent = markTibetan(newcontent, termView, showme);
            // console.log("NEW CONTENT", newcontent);
            setContent(newcontent);
        }
    }, [data, termView]);
    let content_react = ReactHtmlParser(content, { decodeEntities: true });
    //console.log('content_react', content_react);
    let author = data?.related_definitions_author_s ? (
        <span className="defauth">({data.related_definitions_author_s})</span>
    ) : (
        ''
    );

    const selectMe = () => setSelect(dict?.code);

    if (style === 'main') {
        const src = dict?.title || dict?.code.replace('mandala-', 'Defintion ');
        return (
            <div className="inline-def">
                <span className="main-src">
                    <a onClick={selectMe} title="Unselect this definition">
                        {src}
                    </a>
                </span>{' '}
                {content_react} {author}
            </div>
        );
    }
    const myclass = selected ? ' selected' : '';
    let dicttitle = dict?.title;
    if (!dicttitle) {
        dicttitle = `Definition ${n}`;
    }
    if (data?.related_definitions_author_s === 'David Higgins') {
        dicttitle = 'David Higgins';
        content_react = <TranslationPassages data={data} />;
        author = null;
    }
    // console.log('react content', content_react, author);
    return (
        <tr className={`translation${myclass}`}>
            <td className="dict-label">
                <a onClick={selectMe} title="Select this definition">
                    {dicttitle}
                </a>
            </td>
            <td className={`definition${tibclass}`}>
                {content_react}
                {author}
            </td>
        </tr>
    );
}

function TranslationPassages({ data }) {
    const [isOpen, setOpen] = useState(false);
    const toggleMe = () => {
        setOpen(!isOpen);
    };
    const passage_keys = getUniqueKeys(
        data,
        /related_definitions_passage_\d+_content_t/
    );

    const list_content = passage_keys.map((pk, pkn) => {
        return (
            <li key={[data?.id, 'passage', pkn]}>
                <HtmlCustom markup={data[pk]} />
            </li>
        );
    });
    const verb = isOpen ? 'Hide' : 'Show';
    return (
        <div className="tt-passages">
            <h4>
                Example Passages{' '}
                <a className="toggle" onClick={toggleMe}>
                    {verb}
                </a>
            </h4>
            <Collapse in={isOpen}>
                <ol>{list_content}</ol>
            </Collapse>
        </div>
    );
    // return <p>Hello there. Passages belong here! {passage_keys.join(', ')}</p>
}
